
export const base64Encode = (data) => {
    return btoa(unescape(encodeURIComponent(data)));
};

